export default "__VITE_ASSET__DZY31xSv__"